import {ReactElement} from "react";
import * as css from "../styles/revenue-wizard.module.scss";
import {Property} from "../../../contexts/properties/logic";
import LeaseExpirationCurveChart from '../../../pages/bulk-assumptions/components/lease-expiration-curve/LeaseExpirationCurve';
import {VersionType} from "../../../__generated__/generated_types";


interface IExpirationCurveProps {
    property: Property;
    budgetYear: number;
    versionType: VersionType;
    expirations: number[] | null;
    onChange: (values: number[]) => void;
}

export default function ExpirationCurve({
    property,
    budgetYear,
    versionType,
    expirations,
    onChange,
}: IExpirationCurveProps): ReactElement {
    const versionLabel = versionType == VersionType.Reforecast ? "Reforecast" : "Budget";
    const versionYear = versionType == VersionType.Reforecast ? budgetYear - 1 : budgetYear;
    const title = `${versionLabel} ${versionYear}`;

    return (
        <div>
            <h3 className={css.stepTitle}>Set Your Expirations</h3>
            <p className={css.stepParagraph}>Adjust your expected Expirations for each month. If you have existing values in the system, those will be brought in as your starting point.</p>

            <h4 className={css.stepSubtitle}>{title}</h4>
            { versionType == VersionType.Budget ?
                <p className={css.stepParagraph}>Expirations for the Budget season should add up to 100%.</p>
                :
                <p className={css.stepParagraph}>Values populated from your Actuals cannot be adjusted. Though not required, it's recommended for these to add up to 100% for the year.</p>
            }
            { property &&
                <LeaseExpirationCurveChart
                    versionType={versionType}
                    existingValues={expirations}
                    currentProperty={property}
                    onValueChange={onChange}
                />
            }
        </div>
    );
}
